import React, { useMemo } from "react";
import { useTranslation, Trans } from "react-i18next";
import Link from "../../Link";
import MemberBenefitTable, {
  getCriteriaHeading,
  getZMTZiplockRate,
} from "../../MemberBenefitTable";
import SignUpButton from "../../SignUpButton";

const findMaxRateByTier = (coinInterestRates) => {
  const { nodes } = coinInterestRates;
  const maxRateByTier = {}; // Map from vip0 -> value
  for (const node of nodes) {
    const {
      acfCoinInterestRates: { zipupInterateRateV2 },
    } = node;
    for (const tier of Object.keys(zipupInterateRateV2)) {
      const rate = Number(zipupInterateRateV2[tier].rate);
      maxRateByTier[tier] = Math.max(rate, maxRateByTier[tier] || 0);
    }
  }
  return maxRateByTier;
};

const WelcomeToZipCrew = ({ lang, coinInterestRates }) => {
  const { t } = useTranslation();
  const maxRateByTier = useMemo(
    () => findMaxRateByTier(coinInterestRates),
    [coinInterestRates]
  );
  const ziplockApy = useMemo(
    () => getZMTZiplockRate(coinInterestRates),
    [coinInterestRates]
  );
  const getRateText = (tier) => [
    {
      name: t("zmt.welcomeToZipCrew.upTo", {
        amount: maxRateByTier[tier],
      }),
    },
  ];

  const benefits = [
    getCriteriaHeading(
      t("earn.availableAssets.criteria"),
      t("earn.availableAssets.buyAndLock"),
      t("earn.availableAssets.getZiplockAPY", { apy: ziplockApy })
    ),
    {
      title: (
        <>
          <Trans
            i18nKey="zmt.welcomeToZipCrew.interestZipUp"
            components={[<Link to="/earn/">Trading Fees</Link>]}
          />
        </>
      ),
      vip: getRateText("vip0"),
      vip1: getRateText("vip1"),
      vip2: getRateText("vip2"),
      vip3: getRateText("vip3"),
      vip4: getRateText("vip4"),
    },
    {
      title: (
        <>
          <Trans
            i18nKey="zmt.welcomeToZipCrew.tradingFees"
            components={[<Link to="/fee-schedule/">Trading Fees</Link>]}
          />
        </>
      ),
      vip: [{ name: "0% Off" }],
      vip1: [{ name: "10%" }],
      vip2: [{ name: "20%" }],
      vip3: [{ name: "35%" }],
      vip4: [{ name: "50%" }],
    },
  ].concat(t("zmt.welcomeToZipCrew.benefits", { returnObjects: true }));

  return (
    <>
      <div id="welcome-to-zipcrew">
        <div className="container">
          <div className="d-flex flex-column text-center align-items-center w-100">
            <h2
              data-sal="slide-up"
              data-sal-duration="500"
              data-sal-easing="ease-in-quad"
            >
              {t("zmt.welcomeToZipCrew.title")}
            </h2>
            <p
              data-sal="slide-up"
              data-sal-duration="500"
              data-sal-easing="ease-in-quad"
              data-sal-delay="100"
            >
              {t("zmt.welcomeToZipCrew.description")}
            </p>
          </div>

          <MemberBenefitTable
            className="zmt-table mb-4"
            tableTitle={t("earn.availableAssets.memberLevel")}
            benefits={benefits}
            hasAdditionalHeader={true}
          />

          <div className="button-container">
            {lang === "en" && (
              <Link to="/ziplock-terms-conditions/">
                {"Terms & Conditions"}
              </Link>
            )}

            <div className="btn-buy-zmt text-center">
              <SignUpButton className="button button-primary">
                {t("zmt.welcomeToZipCrew.btnBuyZMT")}
              </SignUpButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WelcomeToZipCrew;
